import Vue from 'vue'
import RbToggleBar from '@/elements/toggle-bar/toggle-bar.vue'
Vue.component('rb-toggle-bar', RbToggleBar)

import RbTooltip from '@/elements/tooltip/tooltip.vue'
Vue.component('rb-tooltip', RbTooltip)

import RbSidebar from '@/elements/pdp/minicart/mobile/sidebar.vue'
Vue.component('rb-sidebar', RbSidebar)

import RbSelect from '@/elements/forms/rb-select.vue'
Vue.component('rb-select', RbSelect)

import RbRegistrationCallout from '@/elements/registration-callout/rb-registration-callout.vue'
Vue.component('rb-registration-callout', RbRegistrationCallout)

import RbTextfield from '@/elements/forms/rb-textfield.vue'
Vue.component('rb-textfield', RbTextfield)

import RbTextarea from '@/elements/forms/rb-textarea.vue'
Vue.component('rb-textarea', RbTextarea)

import RbRadio from '@/elements/forms/rb-radio.vue'
Vue.component('rb-radio', RbRadio)

import RbCheckbox from '@/elements/forms/rb-checkbox.vue'
Vue.component('rb-checkbox', RbCheckbox)

import Swiper from '@/scripts/components/swiper/swiper.vue'
Vue.component('swiper', Swiper)

import SwiperSlide from '@/scripts/components/swiper/swiper-slide.vue'
Vue.component('swiper-slide', SwiperSlide)

const RbSwiperBar = () =>
  import(
    /* webpackChunkName: "common-chunk" */ '@/scripts/components/rb-swipe-bar/rb-swiper-bar.vue'
  )
Vue.component('rb-swiper-bar', RbSwiperBar)

import RbAccordion from '@/elements/accordion/accordion.vue'
Vue.component('rb-accordion', RbAccordion)

import RbTabNavigator from '@/elements/editorial/slider/tab-navigator.vue'
Vue.component('rb-tab-navigator', RbTabNavigator)

import RbDummySkeleton from '@/elements/dummy-skeleton/dummy-skeleton.vue'
Vue.component('rb-dummy-skeleton', RbDummySkeleton)

/* TODO: move this inside components */
const RbLoaderGlasses = () =>
  import(/* webpackChunkName: "loader-chunk" */ '@/elements/loader/glasses.vue')
Vue.component('rb-loader-glasses', RbLoaderGlasses)

const RbReportFake = () =>
  import(
    /* webpackChunkName: "report-fake-chunk" */ '@/elements/get-support/report-fake/report-fake.vue'
  )
Vue.component('rb-report-fake', RbReportFake)

const RbInfoBox = () => import('@/elements/info-box/info-box.vue')
Vue.component('rb-info-box', RbInfoBox)

const RbRoxPrescription = () =>
  import(
    /* webpackChunkName: "prescription-chunk" */ '@/elements/prescription/rb-rox-prescription.vue'
  )
Vue.component('rb-rox-prescription', RbRoxPrescription)

const RbRoxPrescriptionPreview = () =>
  import(
    /* webpackChunkName: "prescription-chunk" */ '@/elements/prescription/rb-rox-prescription-preview.vue'
  )
Vue.component('rb-rox-prescription-preview', RbRoxPrescriptionPreview)

import RbFrameAdvisor from '@/elements/frame-genius/frame-advisor/frame-advisor.lazy.vue'
Vue.component('rb-frame-advisor', RbFrameAdvisor)

const RbSizeAdvisor = () => import('@/elements/frame-genius/size-advisor/size-advisor.vue')
Vue.component('rb-size-advisor', RbSizeAdvisor)

const RbFrameGeniusMyAccount = () =>
  import('@/elements/frame-genius/my-account/frame-genius-my-account.vue')
Vue.component('rb-frame-genius-my-account', RbFrameGeniusMyAccount)

const RbContactUs = () =>
  import(
    /* webpackChunkName: "contact-us-chunk" */ '@/elements/get-support/contact-us/rb-contact-us.vue'
  )
Vue.component('rb-contact-us', RbContactUs)

/* TODO: check if this is needed */
const RbRoxDisclaimer = () => import('@/elements/prescription/rb-rox-disclaimer.vue')
Vue.component('rb-rox-disclaimer', RbRoxDisclaimer)

const RbVirtualMirror = () => import('@/elements/virtual-mirror/rb-virtual-mirror')
Vue.component('rb-virtual-mirror', RbVirtualMirror)

import RbLazyMedia from '@/elements/lazy/lazy-media/rb-lazy-media.vue'
Vue.component('rb-lazy-media', RbLazyMedia)

import RbLazyIcon from '@/elements/lazy/lazy-icon/rb-lazy-icon.vue'
Vue.component('rb-lazy-icon', RbLazyIcon)

const RbTransitionBanner = () => import('@/elements/transition-banner/rb-transition-banner.vue')
Vue.component('rb-transition-banner', RbTransitionBanner)

import RbEyewearProtectionOverlayContent from '@/elements/cart/eyewear-protection/rb-eyewear-protection-overlay-content.vue'
Vue.component('rb-eyewear-protection-overlay-content', RbEyewearProtectionOverlayContent)

import RbTrustPilotTyp from '@/elements/trust-pilot/rb-trust-pilot-typ.vue'
Vue.component('rb-trust-pilot-typ', RbTrustPilotTyp)

import RbAccountUpdatedMessageBox from '@/elements/my-account/rb-account-updated-message-box.vue'
Vue.component('rb-account-updated-message-box', RbAccountUpdatedMessageBox)
